import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Catalog } from '@app/core/models/catalog.model';
import { ApiService } from '@app/core/services/api.service';
import { State } from '@ngrx/store';
import { AppState } from '@app/core/ngrx';

/**
 * OrderService
 */
@Injectable({ providedIn: 'root' })
export class OrderService {
  /**
   * url
   */
  public url;
  /**
   * constructor
   * @param {ApiService} apiService
   * @param {HttpClient} http
   */
  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private state: State<AppState>,
  ) {}

  /**
   * getRelatedFrames
   * @returns {Observable<Catalog>}
   */
  getRelatedFrames(frameId): Observable<Catalog> {
    const options = {
      headers: {
        programKey: this.state.getValue().user.profile.program.programKey,
      },
    };
    return this.apiService.get(`/catalog/related-frames/${frameId}`, options);
  }

  getRBAMessage(fpc): Observable<Catalog> {
    const options = {
      headers: {
        programKey: this.state.getValue().user.profile.program.programKey,
      },
    };
    return this.apiService.get(`/catalog/rba/${fpc}`, options);
  }

  postOrder(params) {
    const options = {
      headers: {
        programKey: this.state.getValue().user.profile.program.programKey,
      },
    };
    return this.apiService.post('/order', params, options);
  }
  orderAddressValidation(formBody:any){
    const options = {
      headers: {
        programKey: this.state.getValue().user.profile.program.programKey,
      },
    };
    return this.apiService.post('/order/validate-address', formBody, options);
  }
}
